import script from "./MenuLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuLink.vue?vue&type=script&setup=true&lang=ts"

import "./MenuLink.vue?vue&type=style&index=0&id=3546f23a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3546f23a"]])

export default __exports__